/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Space_Not_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "This space doesn't exist or you don't have access to it. The link may be broken or the space may have been removed." |
*
* @param {Space_Not_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const space_not_found_description = /** @type {((inputs?: Space_Not_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Space_Not_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Space existiert nicht oder du hast keinen Zugriff darauf. Der Link ist möglicherweise ungültig oder der Space wurde entfernt.")
	return /** @type {LocalizedString} */ ("This space doesn't exist or you don't have access to it. The link may be broken or the space may have been removed.")
});